import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface NavigationSidebarState {
    isMinimized: boolean;
    showMobileMenu?: boolean;
}

export interface NavigationSidebarStore extends NavigationSidebarState {
    setIsMinimized: (value: boolean) => void;
    toggleMobileMenu: (show?: boolean) => void;
}

const initialState: NavigationSidebarState = {
    isMinimized: true,
    showMobileMenu: false,
};

export const useNavigationStore = create<NavigationSidebarStore>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setIsMinimized: (value) => set({ isMinimized: value }),
                toggleMobileMenu: (value) => set({ showMobileMenu: value }),
            }),
            {
                name: 'navigation-sidebar-storage',
                partialize: (state) => {
                    const { showMobileMenu, ...rest } = state;
                    return rest; // persist all state except showMobileMenu
                },
            },
        ),
    ),
);
